import math from './expression';
import { Store } from '../redux/stores';
import { loadingActions } from '../redux/actions';

const explodeDices = (explodeOp, eachDice, sides) => {
    let addDices = [];
    for (let dice of eachDice) {
        if (evalOperation(explodeOp, dice)) {
            let v = Array(10).fill(0).map(() => Math.ceil(Math.random() * sides));
            addDices.push(v);
        }
    }

    if (addDices.length > 0) {
        let reexplode = explodeDices(explodeOp, addDices, sides);
        addDices = [...addDices, ...reexplode];
    }

    return addDices;
}

const rerollDices = (rerollOp, eachDice, sides, rerollCount = 0) => {
    let rerolled = [];
    let ignored = [];
    for (let dice of eachDice) {
        if (evalOperation(rerollOp, dice)) {
            let v = Array(10).fill(0).map(() => Math.ceil(Math.random() * sides));
            rerolled.push(v);
            ignored.push(dice[dice.length - 1]);
        }
    }

    if (rerolled.length && rerollCount < 100) {
        let rr = rerollDices(rerollOp, rerolled, sides, ++rerollCount);
        rerolled = [...rerolled, ...rr.add];
        ignored = [...ignored, ...rr.ignore];
    }

    return {
        add:rerolled,
        ignore: ignored
    };
}

const evalOperation = (op, v, sides = 0) => {
    switch(op.operation) {
        case '<':
            return v[v.length-1] < op.value;
        case '<=':
            return v[v.length-1] <= op.value;
        case '==':
            return v[v.length-1] === op.value;
        case '!=':
            return v[v.length-1] !== op.value;
        case '>=':
            return v[v.length-1] >= op.value;
        case '>':
            return v[v.length-1] > op.value;
        default:
            return v[v.length-1] === (op.value || sides);
    }
}

const parseOperation = (expression) => {
    if (!expression) {
        return '';
    }

    let operationRegex = /(<|<=|==|>=|>|!=)?\s*(\d+)/gi;
    let result = operationRegex.exec(expression);
    let value = result[2];

    if (String(parseInt(result[2])) === result[2]) {
        value = parseInt(result[2])
    } else if (String(parseFloat(result[2])) === result[2]) {
        value = parseFloat(result[2])
    }

    return {
        operation: result[1],
        value: value
    }
}

const parseOptions = (opts) => {
    if (!opts) {
        return {};
    }

    opts = String(opts);

    if (!/{(.*?)}/gi.test(opts)) {
        return {};
    }

    let result = {};
    let keyValueRegex = /([a-z0-9_]+?):\s*(.*?)\s*[,}]+/gi;
    let match = null;
    let p = 0;
    while(p++<100 && null !== (match = keyValueRegex.exec(opts))) {
        let value = match[2];
        if (value === 'true') {
            value = true;
        }
        if (value === 'false') {
            value = false;
        }

        if (String(parseFloat(value)) === value) {
            value = parseFloat(value);
        }

        if (String(parseInt(value)) === value) {
            value = parseInt(value);
        }

        result[match[1]] = value;
    }

    return result;
}

const savedLastValues = {};

export default class DiceParser {

    constructor() {
        this.hasCritical = false;
        this.isCritical = false;
    }

    setCritical(crit) {
        this.isCritical = crit;
    }

    parse (expression, groupId) {
        let rolls = [];
        let finalRolls = [];
        let findDiceRegex = /(\d+)d(\d+|[fF])({.*?})*/gi;

        expression = DiceParser.processCritical(expression, this.isCritical);

        let params;
        let parsedExpression = expression.replace(findDiceRegex, '$1d$2');
        let resultExpression = expression;
        let withIgnoredExpression = '';
        let finalResult = null;
        let minimumExpression = expression;
        let minimumResult = null;
        let maximumExpression = expression;
        let maximumResult = null;
        let saveFinalAsLast = true;

        let p = 0;
        while(p++<100 && null !== (params = findDiceRegex.exec(expression))){
            let originalExpression = params[0];
            let num = parseInt(params[1]);
            let sides = ['f','F'].indexOf(params[2]) >= 0 ? 'F' : parseInt(params[2]);
            let options = parseOptions(params[3] || '');
            let critical = false;
            let criticalOp = parseOperation(options.critical || null);
            let failOp = parseOperation(options.fail || null);
            let successOp = parseOperation(options.success || null);
            let countSuccess = 0;
            let countFailures = 0;
            let countCritical = 0;
            let countFail = 0;
            let criticalEach = [];
            let failEach = [];
            let values = [];
            let final = [];
            let ignored = [];

            saveFinalAsLast = options.save ?? saveFinalAsLast;

            if (num === 0) {
                values.push(Array(10).fill(0));
                final.push(0);
                criticalEach.push(false);
                failEach.push(false);
            } else {
                for (let d=0; d<num; d++) {
                    let v = Array(10).fill(0);
                    if (sides === 'F') {
                        v = v.map(() => Math.ceil(Math.random() * 3) - 2);
                    } else {
                        v = v.map(() => Math.ceil(Math.random() * sides));
                    }
                    values.push(v);
                    final.push(v[v.length-1]);

                    critical = critical || evalOperation(criticalOp, v, (sides === 'F' ? 1 : sides));

                    criticalEach.push(evalOperation(criticalOp, v, (sides === 'F' ? 1 : sides)))
                    failEach.push(evalOperation(failOp, v, (sides === 'F' ? -1 : 1)))

                    if (options.count && sides !== 'F') {
                        let isSuccess = evalOperation(successOp, v);
                        let isCritical = evalOperation(criticalOp, v, sides);
                        let isFail = evalOperation(failOp, v, 1);
                    
                        if (isSuccess) {
                            countSuccess++;
                        } else {
                            countFailures++;
                        }

                        if (isCritical) {
                            countCritical++;
                        }

                        if (isFail) {
                            countFail++;
                        }
                    }
                }
            }

            if (options.explode && sides !== 'F') {
                let explodeOp = parseOperation(options.explode);
                let addDices = explodeDices(explodeOp, values, sides);
                values = [...values, ...addDices];
                final = [...final, ...addDices.map(v=>v[v.length-1])];
            }

            let valuesEnable = [];
            if (options.reroll && sides !== 'F') {
                let rerollOp = parseOperation(options.reroll);
                let reroll = rerollDices(rerollOp, values, sides);

                values = [...values, ...reroll.add];
                final = [...final, ...reroll.add.map(v=>v[v.length-1])];
                valuesEnable = values.map(v => v[v.length-1]).filter(i => reroll.ignore.indexOf(i) < 0);
                ignored = reroll.ignore.filter((v, i, self) => {
                    return self.indexOf(v) === i;
                });
            } else {
                valuesEnable = values.map(v => v[v.length-1]);
            }

            withIgnoredExpression = withIgnoredExpression || resultExpression;
            resultExpression = resultExpression.replace(originalExpression, `(${valuesEnable.join('+')})`);
            minimumExpression = minimumExpression.replace(originalExpression, `(${values.map(() => (sides === 'F' ? -1 : 1)).join('+')})`)
            maximumExpression = maximumExpression.replace(originalExpression, `(${values.map(v => (sides === 'F' ? 1 : sides)).join('+')})`)

            let replacedIgnores = [];
            let count = 0;
            
            for(let v of values) { 
                let i = v[v.length-1];
                if (ignored.indexOf(i) >= 0) {
                    replacedIgnores[count] = [replacedIgnores[count], `{${i}}`].filter(i => Boolean(i)).join('');
                } else {
                    replacedIgnores[count] = [replacedIgnores[count], i].filter(i => Boolean(i) || !isNaN(i)).join('');
                    count++;
                }
            }
            withIgnoredExpression = withIgnoredExpression.replace(originalExpression, replacedIgnores.join('+'))

            this.hasCritical = critical;

            rolls.push({
                values,
                final,
                options,
                critical,
                ignored,
                criticalEach,
                failEach,
                sides,
                countSuccess,
                countFailures,
                countCritical,
                countFail,
                expression: originalExpression
            })
        }

        try {
            finalResult = math.evaluate(resultExpression);
            minimumResult = math.evaluate(minimumExpression);
            maximumResult = math.evaluate(maximumExpression);

            finalRolls = Array(10).fill('').map(() => minimumResult + Math.round(Math.random() * (maximumResult-minimumResult)));
            finalRolls[9] = finalResult;

            if (saveFinalAsLast && groupId) {
                savedLastValues[groupId] = finalResult;
            }
        } catch (e) {
            finalResult = "?";
            finalRolls = Array(10).fill('?');
            Store.dispatch(loadingActions.showError(e));
            // Colocar aqui o show do erro apenas
        }

        return {
            rolls,
            finalRolls,
            parsedExpression,
            originalExpression: expression,
            resultExpression: withIgnoredExpression,
            finalResult,
            minimumResult,
            maximumResult,
            timestamp: (new Date()).getTime() + Math.round(10000 + Math.random()*89999)
        };
    }

    static getLastValue(groupId) {
        return savedLastValues[groupId] ? savedLastValues[groupId] : 0;
    }

    static processCritical (content, isCritical) {
        const isCritRegEx = /#critical\((.*?)\)#/gi;
        const isRegularRegEx = /#regular\((.*?)\)#/gi;

        if (isCritical) {
            return content.replace(isCritRegEx, '$1').replace(isRegularRegEx, '');
        }

        return content.replace(isRegularRegEx, '$1').replace(isCritRegEx, '');
    }

    static processLastValue(content, groupId) {
        return content.replace(/\[\s*lastvalue\s*\]/gi, DiceParser.getLastValue(groupId));
    }
};